import { Box } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';

const containerStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: Colors.ArmyGreen100,
  paddingY: 'padding_16',
};

const NoResultsFound = () => {
  return (
    <Box sx={containerStyle}>
      <Text>No results found for the selected filters.</Text>
    </Box>
  );
};

export default NoResultsFound;
